import React from "react";
import Button from "../../../../shared/ui/inputs/classicButton.js";
import DownloadableList from "../downloadableList/downloadableList.js";
import OrderInfo from "../orderInfo/orderInfo.js";
import "./style.css";
export default function ContainerWithDownloadables(props) {
    return (React.createElement("div", { className: "container-with-downloadables" },
        React.createElement(OrderInfo, { ...props }),
        React.createElement(DownloadableList, { showDownloadAllButton: props.order.hasDownloadAllButton }),
        React.createElement("div", { className: "order-info-container" },
            React.createElement(Button, { text: "Wr\u00F3\u0107 do galerii", value: "go-to-gallery", version: "alternative", onClick: () => window.open("/client/gallery", "_blank") }))));
}
